import { Skeleton } from '@/components/skeleton'

export const RestaurantCardSkeleton = () => {
    return (
        <div className="flex flex-col">
            <Skeleton
                className="min-w-[100%] max-w-[100%] bg-black/20 rounded-[20px] overflow-hidden flex items-center"
                style={{
                    aspectRatio: '16 / 9',
                }}
            />

            <div className="mt-3" />

            <Skeleton className="min-h-[30px] max-h-[30px] min-w-full rounded-[6px]" />
            <div className="mt-2" />
            <Skeleton className="min-h-[30px] max-h-[30px] min-w-full rounded-[6px]" />
        </div>
    )
}
